import { useState } from 'react';

import { Text } from '../cdl/Text/Text';
import { CustomerGroupSelect } from '../common/form-elements/CustomerGroupSelect/CustomerGroupSelect';
import { translate } from '../common/helpers/translate.helper';
import { Box } from '../common/ui/Box';

import { FailedRequisitionsTable } from './FailedRequisitionsTable';

export const FailedRequisitionsSection = () => {
    const [groupId, setGroupId] = useState('');

    return (
        <Box display="flex" gap={16} flexDirection="column" alignItems="flex-start">
            <Text variant="title" as="h2">
                {translate('integrationsOverview.failedRequisitionsTitle')}
            </Text>

            <Box width="400px">
                <CustomerGroupSelect
                    label={translate('integrationsOverview.groupLabel')}
                    value={groupId}
                    onChange={(selectedGroupId) => setGroupId(selectedGroupId || '')}
                />
            </Box>

            <FailedRequisitionsTable groupId={groupId || undefined} />
        </Box>
    );
};
